import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { AppConfig } from 'src/app/configs/app.config';
import { DestroyNotifierComponent } from 'src/app/core/component/destroy/destroy-notifier.component';
import { Paging } from 'src/app/core/services/http/general/classes/paging';
import { Status } from 'src/app/core/services/http/general/enums/status';
import { RoomAdapterService } from 'src/app/core/services/http/room/adapters/room-adapter.service';
import { Room } from 'src/app/core/services/http/room/interfaces/room';
import { RoomService } from 'src/app/core/services/http/room/room.service';
import { ObservableWrapperService } from 'src/app/core/services/observable-wrapper/observable-wrapper.service';
import { AutoCompleteItem } from '../../interfaces/autocomplete-item';

@Component({
    selector: 'app-auto-complete-room',
    templateUrl: './auto-complete-room.component.html',
    standalone: false
})
export class AutoCompleteRoomComponent extends DestroyNotifierComponent {
  @Input() form: UntypedFormGroup | undefined;
  @Input() controlName = 'defaultRoom';
  /** Wrapper classes, e.g. `app-input`, `app-input w-100`, `app-input-inline`. */
  @Input() className = 'app-input';
  @Input() disabled = false;
  /** ID for the internal combobox input (for label association and WCAG 3.3.2). */
  @Input() inputId: string | undefined;
  /** WCAG 3.3.1 — id of the validation message element to link via aria-describedby. */
  @Input() errorElementId: string | undefined;
  /** WCAG 3.3.1 — expose invalid state on the combobox input. */
  @Input() ariaInvalid: boolean | undefined;

  get effectiveInputId(): string {
    return this.inputId ?? `${this.controlName}-combobox`;
  }

  rooms: AutoCompleteItem[] = [];
  paging = new Paging({ pageSize: AppConfig.AutoComplete.pageSize });

  constructor(
    private roomService: RoomService,
    private roomAdapterService: RoomAdapterService,
    private observableWrapperService: ObservableWrapperService
  ) {
    super();
  }

  onSelectChangeRoom(item: AutoCompleteItem): void {
    if (this.controlName) {
      this.form?.get(this.controlName)?.setValue(item);
      this.form?.get(this.controlName)?.markAsDirty()
    }
  }

  onSearchChangeRoom(filter: string): void {
    this.observableWrapperService.unsubscribeWrapper<Room[]>(
      this.roomService.getAll(this.paging, { filter, status: Status.Active }),
      this.destroyNotify,
      rooms => {
        this.rooms = this.roomAdapterService.roomToAutoCompleteItem(rooms);
      }
    );
  }
}
